module.exports = __webpack_public_path__ + "img/paciente.f35e76f0.svg";